import {
  addDoc,
  collection,
  doc,
  getDocs,
  query,
  setDoc,
  where,
} from "firebase/firestore";
import { db } from "../firebase.config";
import { decompress } from "./compress";

export async function fetchTranslations(language, page) {
  try {
    const eRef = collection(db, "translations");
    const q = query(
      eRef,
      where("language", "==", language),
      where("page", "==", page)
    );
    const querySnap = await getDocs(q);
    const trs = [];
    querySnap.forEach((doc) => {
      return trs.push(doc.data());
    });
    var tr = null;
    if (trs.length > 0) {
      tr = trs[0];
    }
  } catch (error) {
    console.log(error);
  }
  return tr;
}

export async function fetchAllTranslations() {
  try {
    const eRef = collection(db, "translations");
    const q = query(eRef);
    const querySnap = await getDocs(q);
    const trs = [];
    querySnap.forEach((doc) => {
      return trs.push(doc.data());
    });
    return trs;
  } catch (error) {
    console.log(error);
    return [];
  }
}

export async function fetchAllTranslationsForLanguage(lang) {
  try {
    const eRef = collection(db, "translations");
    const q = query(eRef, where("language", "==", lang));
    const querySnap = await getDocs(q);
    const trs = [];
    querySnap.forEach((doc) => {
      return trs.push(doc.data());
    });
    return trs;
  } catch (error) {
    console.log(error);
    return [];
  }
}

export async function updateTranslations(tr) {
  try {
    if (!tr.uid || tr.uid.length === 0) {
      const doc = await addDoc(collection(db, "translations"), tr);
      tr.uid = doc.id;
    }
    await setDoc(doc(db, "translations", tr.uid), tr);
    return { translation: tr, error: "" };
  } catch (error) {
    console.log(error.message);
    return { translation: null, error: error.message };
  }
}

export async function fetchAllLanguages() {
  const trs = await fetchAllTranslations();
  var langs = {};
  var xlangs = [];
  for (var tr of trs) {
    if (langs[tr.language] === undefined) {
      langs[tr.language] = tr.language;
      xlangs.push(tr.language);
    }
  }
  return xlangs.sort((a, b) => a - b);
}

export async function fetchUser(userUid) {
  try {
    const eRef = collection(db, "users");
    const q = query(eRef, where("userUid", "==", userUid));
    const querySnap = await getDocs(q);
    const usrs = [];
    querySnap.forEach((doc) => {
      return usrs.push(doc.data());
    });
    var usr = null;
    if (usrs.length > 0) {
      usr = usrs[0];
    }
  } catch (error) {
    console.log(error);
  }
  return usr;
}

export async function fetchUserByEmail(email) {
  try {
    const eRef = collection(db, "users");
    const q = query(eRef, where("email", "==", email));
    const querySnap = await getDocs(q);
    const usrs = [];
    querySnap.forEach((doc) => {
      return usrs.push(doc.data());
    });
    var usr = null;
    if (usrs.length > 0) {
      usr = usrs[0];
    }
  } catch (error) {
    console.log(error);
  }
  return usr;
}

export async function updateUser(u) {
  try {
    var uu = await fetchUser(u.userUid);
    if (!uu) {
      const x = await addDoc(collection(db, "users"), u);
      u.userUid = x.id;
      await setDoc(doc(db, "users", u.userUid), u);
      return { user: u, error: "" };
    } else {
      await setDoc(doc(db, "users", u.userUid), u);
      return { user: u, error: "" };
    }
  } catch (error) {
    console.log(error.message);
    return { user: null, error: error.message };
  }
}

export async function fetchMatchByMatchId(matchId) {
  try {
    const eRef = collection(db, "matches");
    const q = query(eRef, where("matchId", "==", matchId));
    const querySnap = await getDocs(q);
    const usrs = [];
    querySnap.forEach((doc) => {
      return usrs.push(doc.data());
    });
    var usr = null;
    if (usrs.length > 0) {
      usr = usrs[0];
    }
  } catch (error) {
    console.log(error);
  }
  return usr;
}

export async function fetchMatches() {
  try {
    const eRef = collection(db, "matches");
    const q = query(eRef);
    const querySnap = await getDocs(q);
    const usrs = [];
    querySnap.forEach((doc) => {
      return usrs.push(doc.data());
    });
    return usrs;
  } catch (error) {
    console.log(error);
    return [];
  }
}

export async function updateMatch(m) {
  try {
    // let match = await fetchMatchByMatchId(m.matchId);
    // if (!match) {
    //   const doc = await addDoc(collection(db, "matches"), m);
    // }
    // else {
    //   await setDoc(doc(db, "matches", m.matchId), m);
    // }
    await setDoc(doc(db, "matches", m.matchId), m);
    return null;
  } catch (error) {
    console.log(error.message);
    return error.message;
  }
}

export async function fetchSessionDataBySessionIdPeriodIdAthleteId(
  activityId,
  periodId,
  athleteId
) {
  try {
    const eRef = collection(db, "sensordata");
    const q = query(
      eRef,
      where("activityId", "==", activityId),
      where("periodId", "==", periodId),
      where("athleteId", "==", athleteId)
    );
    const querySnap = await getDocs(q);
    const usrs = [];
    querySnap.forEach((doc) => {
      return usrs.push(doc.data());
    });
    var usr = null;
    if (usrs.length > 0) {
      usr = usrs[0];
    }
  } catch (error) {
    console.log(error);
  }
  return usr;
}

export async function updateSensorData(sd) {
  try {
    await setDoc(doc(db, "sensordata", sd.id), sd);
    return null;
  } catch (error) {
    console.log(error.message);
    return error.message;
  }
}

export async function loadPlayerSensor(match, tm, selperiod) {
  const aths = tm.catapultPlayers;
  const catsession =
    tm.name === "AFL Umpires"
      ? match.umpires_catapult_session
      : tm.name === match.home_squad
      ? match.home_catapult_session
      : match.away_catapult_session;
  if (!aths) {
    return;
  }

  if (!tm.playerSensorData) {
    tm.playerSensorData = [[], [], [], []];
  }
  if (tm.playerSensorData[selperiod - 1].length === 0) {
    // setLoading(true);
    let catperiod = null;
    for (var per of catsession.periods) {
      if (per.name.toUpperCase() === `QUARTER ${selperiod}`) {
        catperiod = per;
        break;
      }
    }
    let plsds = [];
    for (var ath of aths) {
      // setLoadingMessage(
      //   `Loading Quarter ${selperiod} sensor data for ${ath.first_name} ${ath.last_name} ...`
      // );
      if (!ath.playerSensorData) {
        ath.playerSensorData = [[], [], [], []];
      }
      if (ath.playerSensorData[selperiod - 1].length > 0) {
        continue;
      }
      const sd = await fetchSessionDataBySessionIdPeriodIdAthleteId(
        catsession?.id,
        catperiod.id,
        ath.id
      );
      if (sd) {
        ath.playerSensorData[selperiod - 1] = JSON.parse(decompress(sd.data));
        plsds.push({
          id: ath.id,
          name: ath.first_name + " " + ath.last_name,
          data: JSON.parse(decompress(sd.data)),
        });
      }
    }
    tm.playerSensorData[selperiod - 1] = plsds;
    // setLoading(false);
  }
}

export async function fetchEventsDataByMatchId(matchId) {
  try {
    const eRef = collection(db, "eventsdata");
    const q = query(eRef, where("matchId", "==", matchId));
    const querySnap = await getDocs(q);
    const usrs = [];
    querySnap.forEach((doc) => {
      return usrs.push(doc.data());
    });
    var usr = null;
    if (usrs.length > 0) {
      usr = usrs[0];
    }
    return usr;
  } catch (error) {
    console.log(error);
  }
  return null;
}

export async function updateEventsData(ed) {
  try {
    let eventsdata = await fetchEventsDataByMatchId(ed.matchId);
    if (!eventsdata) {
      const doc = await addDoc(collection(db, "eventsdata"), ed);
      ed.uid = doc.id;
    } else {
      ed.uid = eventsdata.uid;
    }
    await setDoc(doc(db, "eventsdata", ed.uid), ed);
    return null;
  } catch (error) {
    console.log(error.message);
    return error.message;
  }
}
